/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/

import React from 'react';
import { Grid, Toolbar, Box, Typography, Link } from '@mui/material';
import '../styles/local-style.css';
import { PrayButton, PrayView } from '../../common';

export default function PreviewView(props) {
  return (
    <>
      <PrayView viewName={props.header}>
        <Grid sx={{ flex: 1, height: '100%', p: 0, position: 'relative' }}>
          <Toolbar />
          <img src={props.imageUrl} alt='preview' className='preview-image' />
          <div className='preview-modal'>
            <Box sx={{ backgroundColor: '#E3AF4A', p: 4, border: '1px solid rgba(0, 0, 0, 0.12)', transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms', borderRadius: 1, maxWidth: '30%' }}>
              <Typography variant="h3" sx={{ color: '#000' }}>
                {props.header}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 4, mb: 4 }}>
                {props.content}
              </Typography>
              <PrayButton variant='contained' text={props.buttonText} viewName={props.header}>
                <Link href="mailto:aaron.magnuson@pray.com" sx={{color: '#FFF'}} target="_blank" rel="noreferrer">{props.buttonText}</Link>
                {/* {props.buttonText} */}
              </PrayButton>
            </Box>
          </div>
        </Grid>
      </PrayView>
    </>
  );
};
